import PolicyChange from 'edge/endorsement/common/models/PolicyChange';
import _ from 'underscore';

export default (function ($q, EndorsementService) {

    var ACTIONS = {
        saveEndorsement: function saveEndorsement(model) {
            return EndorsementService.saveEndorsement(model.policyChange).then(function (pc) {
                model.policyChange = new PolicyChange(pc);
                return model;
            });
        },
        quote: function quote(model) {
            return EndorsementService.quoteEndorsement(model.policyChange.jobID).then(function (pc) {
                model.policyChange = new PolicyChange(pc);
                return model;
            });
        },
        saveCoverages: function saveCoverages(model) {
            var lobCoverages = _.mapObject(model.policyChange.lobData, function (lob) {
                return lob.offerings[0].coverages;
            });

            return EndorsementService.updateCoverages(model.policyChange.jobID, lobCoverages).then(function (pc) {
                model.policyChange = new PolicyChange(pc);
                return model;
            });
        },
        startEndorsement: function startEndorsement(model) {
            return ACTIONS.saveEndorsement(model);
        }
    };

    var ACTION_MESSAGES = {
        saveCoverages: {
            error: {
                title: 'endorsement.ho.config.Unable to save coverages change',
                message: 'endorsement.ho.config.An error occurred while attempting to save coverage changes'
            },
            progress: {
                message: 'endorsement.ho.config.Saving coverage changes'
            }
        },
        saveEndorsement: {
            error: {
                title: 'endorsement.common.config.Unable to save draft policy change',
                message: 'endorsement.common.config.An error occurred while attempting to save the policy change.'
            },
            progress: {
                message: 'endorsement.common.config.Saving policy change'
            }
        },
        startEndorsement: {
            error: {
                title: 'endorsement.common.config.Unable to start policy change',
                message: 'endorsement.common.config.An error occurred while attempting to start the policy change.'
            },
            progress: {
                message: 'endorsement.common.config.Starting policy change'
            }
        },
        quote: {
            error: {
                title: 'endorsement.common.config.Unable to quote policy change',
                message: 'endorsement.common.config.An error occurred while attempting to quote the policy change.'
            },
            progress: {
                message: 'endorsement.common.config.Quoting policy change'
            }
        }
    };

    return function (step, junction) {

        junction('HOEntry', true).onNext.doAction(ACTIONS.startEndorsement, ACTION_MESSAGES.startEndorsement).thenBranch(function (model) {
            if (model.nextSteps) {
                if (model.nextSteps.valuables) {
                    return 'HOValuables';
                }
                if (model.nextSteps.mortgagee) {
                    return 'HOMortgagee';
                }
                return 'HOCoverages';
            }
        }, function () {
            return 'HOendorsementError';
        });

        step('HOValuables').onNext.doAction(ACTIONS.saveEndorsement, ACTION_MESSAGES.saveEndorsement).thenBranch(function (model) {
            return model.nextSteps.mortgagee ? 'HOMortgagee' : 'HOCoverages';
        }, function () {
            return 'HOendorsementError';
        }).data({
            'isInOrPastSubflow': true
        });

        step('HOMortgagee').onNext.doAction(ACTIONS.saveEndorsement, ACTION_MESSAGES.saveEndorsement).thenGoTo('HOCoverages', 'HOendorsementError').data({
            'isInOrPastSubflow': true
        });

        step('HOCoverages').onNext.doAction(ACTIONS.saveCoverages, ACTION_MESSAGES.saveCoverages).thenGoTo('HOPreQuote', 'HOendorsementError');

        step('HOPreQuote').onNext.doAction(ACTIONS.quote, ACTION_MESSAGES.quote).thenGoTo('HODone', 'HOendorsementError');

        junction('HOendorsementError');
        step('HODone');
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/conditional?if=endorsement-products&equals=Homeowners!./common/js/src/edge/endorsement/ho/config/FlowConfig.js
// module id = 442
// module chunks = 0